export enum OccurrenceTypeEnum {
  PREVENTIVE = 'P',
  CORRECTIVE = 'C',
  ASSISTANCE = 'A',
  WINCH = 'W',
  IN_DEALERSHIP = 'D',
  SINISTRO = 'S',
  SINISTER = 'S',
  SINISTER_EXT = 'SINISTER',
}

export enum OccurrenceTypeLabelEnum {
  P = 'Preventiva',
  C = 'Corretiva',
  PC = 'Preventiva e Corretiva',
  A = 'Socorro',
  W = 'Guincho',
  D = 'Na Concessionária',
  S = 'Sinistro',
  SINISTER = 'Sinistro',
  /** Backend envia Claim para Sinistro */
  CLAIM = 'Sinistro',
  Claim = 'Sinistro',
}